/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner-wrap[_ngcontent-%COMP%]{position:absolute;height:100%;width:100%;background-color:rgba(187,187,187,.5);z-index:2}.loading-spinner[_ngcontent-%COMP%]{position:relative;left:calc(50% - 39px);top:calc(50% - 60px);border:8px solid #f3f3f3;border-top:8px solid #ccc;border-radius:50%;width:75px;height:75px;animation:1s linear infinite spin}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}\n/*# sourceMappingURL=loading-spinner.component.css.map*/"];
export { styles as styles };
